import { HorizontalLayout } from "@lib/titan2/dist/game/control/layout/HorizontalLayout";
import { deepEquals } from "./deepEquals";
/**
 * A horizontal layout with a fixed spacing independent of the rendered child size.
 */
export class HorizontalFixedLayout extends HorizontalLayout {
    equals(other) {
        return deepEquals(other, this);
    }
    getChildSize(a) {
        const size = super.getChildSize(a);
        size.x = 0;
        return size;
    }
    clone() {
        return new HorizontalFixedLayout(this.spacing, this.align, this.reverseOrder);
    }
}
//# sourceMappingURL=HorizontalFixedLayout.js.map